module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "editable-table"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.sortedRows,
      "height": "calc(50vh - 105px)",
      "empty-text": "No data"
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('TableColumn', {
    staticClass: "select",
    attrs: {
      "prop": "select",
      "label": "",
      "width": "35",
      "fixed": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "select",
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.selectRow(scope.row)
            }
          }
        }, [_c('input', {
          attrs: {
            "type": "radio"
          },
          domProps: {
            "checked": _vm.selectedItemId === scope.row.id
          }
        })])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.visibleColumns), function(col) {
    return _c('TableColumn', {
      key: col.name,
      attrs: {
        "data-column": col.name,
        "prop": col.name,
        "label": col.displayName,
        "class-name": ("column__" + (col.name)),
        "width": "154",
        "fixed": col.name == 'name',
        "sortable": "custom"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('generic-input', {
            attrs: {
              "col": col,
              "row": scope.row,
              "onChange": _vm.updateRow.bind(null, scope.row.id, col.name)
            }
          })]
        }
      }])
    })
  }), _vm._v(" "), _c('TableColumn', {
    staticClass: "duplicate",
    attrs: {
      "prop": "duplicate",
      "label": "",
      "width": "35"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "duplicate",
          attrs: {
            "title": "duplicate"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.duplicateRow(scope.row)
            }
          }
        }, [_c('Copy', {
          staticClass: "button"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('TableColumn', {
    staticClass: "destroy",
    attrs: {
      "prop": "destroy",
      "label": "",
      "width": "35"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "destroy",
          attrs: {
            "title": "delete"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.deleteRow(scope.row)
            }
          }
        }, [_c('Delete', {
          staticClass: "button"
        })], 1)]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b0808dc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditableTable.vue
// module id = 748
// module chunks = 2